﻿import {
  appendQueryParameters,
  fetchBaseQueryWrapper,
} from "@/services/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";

export const conditionalAccessApi = createApi({
  reducerPath: "conditionalAccessApi",
  baseQuery: fetchBaseQueryWrapper({
    path: "conditionalAccess",
  }),
  endpoints: (build) => ({
    getConditionalAccessGroup: build.query({
      query: (id) => id,
      transformResponse: ({ data }) => data,
    }),
    getConditionalAccessGroups: build.query({
      query: (queryParameters) => appendQueryParameters("", queryParameters),
    }),
    getConditionalAccessGroupMembers: build.query({
      query: ({ id, domain, page, pageSize, userId }) =>
        `${id}/members?domain=${domain}&page=${page}&pageSize=${pageSize}&userId=${userId}`,
      transformResponse: ({ data }) => data,
    }),
    saveConditionalAccessGroup: build.mutation({
      query: ({ id, metadata }) => ({
        url: `${id}/metadata`,
        method: "POST",
        body: metadata,
      }),
    }),
  }),
});

export const {
  useGetConditionalAccessGroupQuery,
  useGetConditionalAccessGroupsQuery,
  useGetConditionalAccessGroupMembersQuery,
  useSaveConditionalAccessGroupMutation,
} = conditionalAccessApi;
